/**
 * Название полей ввода в форме оплаты.
 */
export enum Field {
  /**
   * Поле для ввода суммы.
   */
  AMOUNT = 'amount',

  /**
   * Поле с полной суммой займа.
   */
  AMOUNT_FULL = 'amountFull',
}
